module.exports = __webpack_public_path__ + "img/other-link.2de807cd.png";